// Only operation identity and a payload digest are retained, never session/contact data.
const storageKey = userId => `openruns:create-invite:${userId}`;
const canonical = value => JSON.stringify(value, Object.keys(value).sort());
export async function digest(value) {
  const bytes = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(value));
  return Array.from(new Uint8Array(bytes), b => b.toString(16).padStart(2, '0')).join('');
}
export function pendingCreation(userId) {
  try { return JSON.parse(localStorage.getItem(storageKey(userId)) || 'null'); } catch { return null; }
}
export async function creationIdentity(userId, payload) {
  if (!userId) throw new Error('Sign in before creating a session');
  const hash = await digest(canonical(payload));
  const existing = pendingCreation(userId);
  if (existing) {
    if (existing.payloadHash !== hash) throw new Error('A previous Create & Invite submission needs checking before creating a different session.');
    return existing;
  }
  const key = window.crypto.randomUUID();
  const value = { key, operationId: await digest(`${userId}:${key}`), payloadHash: hash };
  // Synchronous write before POST; double submits reuse this identity.
  const raced = pendingCreation(userId);
  if (raced) {
    if (raced.payloadHash !== hash) throw new Error('A different submission is pending.');
    return raced;
  }
  localStorage.setItem(storageKey(userId), JSON.stringify(value));
  return value;
}
export function acknowledgeCreation(userId, operationId) {
  if (pendingCreation(userId)?.operationId === operationId) localStorage.removeItem(storageKey(userId));
}
